import { Suspense } from "react";
import "./App.scss";
import Booking from "./Components/Booking/Booking";
import Features from "./Components/Features/Features";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import MainBody from "./Components/MainBody/MainBody";
import NavigationBar from "./Components/NavigationBar/NavigationBar";
import Popup from "./Components/Popup/Popup";
import Story from "./Components/Story/Story";
import Tours from "./Components/Tours/Tours";

function App() {
  return (
    <>
      <Suspense fallback={<div> loading....</div>}>
        <Popup />
        <NavigationBar />
        <Header />
        <MainBody />
        <Features />
        <Tours />
        <Story />
        <Booking />
        <Footer />
      </Suspense>
    </>
  );
}

export default App;
